import React, { useEffect } from 'react';
import { useParams }        from 'react-router';
import { Link }             from 'react-router-dom';
import scrollToComponent    from 'react-scroll-to-component';
import { getRoute }         from 'pursuit/routes/routes';

export default function EventsPast(props) {
    const { scrollTo } = props;
    const params = useParams();

    const scrollReferences = [];
    let scrollToLabel = '';

    useEffect(() => {
        if (typeof params.event !== 'undefined') {
            scrollToLabel = params.event;
        }

        if (typeof scrollTo !== 'undefined') {
            scrollToLabel = scrollTo;
        }

        scrollToComponent(
            scrollReferences[scrollToLabel], {
                offset: -110,
                align: 'top',
                duration: 300,
            }
        );
    });

    return (
        <section role="main" className="events">
            <div className="grid-center">
                <div className="col-11">

                    <h2 className="content-title justify-center minor-margin--bottom">
                        Past Events
                    </h2>

                    <div className="grid-center grid-top major-margin--bottom">
                        <div className="col-11">
                            <div
                                className="section-title text-large highlight"
                                ref={section => scrollReferences['womens-wellness'] = section}
                            >
                                Women's Wellness Event
                            </div>
                        </div>
                        <div className="col-4_xs-11_md-4 no-padding--bot">
                            <div className="img-container minor-margin--bottom">
                                <img
                                    width="100%"
                                    src="/img/promos/womens-wellness/womens-wellness.png"
                                />
                            </div>
                        </div>
                        <div className="col-7_xs-11_md-7 no-padding--bot">
                            <p>Please join us us for a workshop to explore and learn how you can support your health at different life stages (not to mention yuumy refreshments, prizes, and gift bags!)</p>

                            <ul className="styled minor-margin--bottom">
                                <li>
                                    <span className="bold">When:</span> Sunday September 29th
                                </li>
                                <li className="minor-margin--bottom">
                                    <span className="bold">11:00 - 12:30:</span> Fertility, Pre-Natal & Post-Natal
                                    <ul className="styled bitof-margin--top">
                                        <li>Nutrition and Supplements to Support the Journey to Motherhood</li>
                                        <li>Stages of Development in Children</li>
                                        <li>How to Prepare your body before the baby and Return to Health afterwqard</li>
                                    </ul>
                                </li>
                                <li>
                                    <span className="bold">1:00 - 2:30:</span> Stress & Hormonal Changes
                                    <ul className="styled bitof-margin--top">
                                        <li>Stress, Hormones and Strategies to Cope</li>
                                        <li>Pre-Menopause, Peri-Menopause and Menopause</li>
                                        <li>Stress and Pain Perception</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="grid-center major-margin--bottom">
                        <div className="col-11">
                            <div
                                className="section-title text-large highlight"
                                ref={section => scrollReferences['2nd-anniversary'] = section}
                            >
                                2 Year Anniversary Open House
                            </div>
                        </div>
                        <div className="col-4_xs-11_md-4 no-padding--bot">
                            <div className="img-container minor-margin--bottom">
                                <img
                                    width="100%"
                                    src="/img/promos/2nd-anniversary/2nd-anniversary.webp"
                                />
                            </div>
                        </div>
                        <div className="col-7_xs-11_md-7 no-padding--bot">
                            <p>Come join us the afternoon of <span className="bold">Saturday, September 28th</span> to celebrate our 2 Year Anniversary in the Leslieville Community!</p>

                            <p>We are so thankful to be a source of support, health, and wellness for the neighbourhood and look forward to helping you meet all your upcoming health goals. Please come pop in anytime between 1pm and 4pm to check out our beautiful space and meet the various clinicians.</p>

                            <p>Pop by anytime to find out about the services we offer!</p>

                            <p>We will also be holding a free Acupuncture workshop with demos, a restorative yoga class, and lots of fun prizes and information on our upcoming added services.</p>
                        </div>
                    </div>

                    <div className="grid-center major-margin--bottom">
                        <div className="col-11">
                            <div
                                className="section-title text-large highlight"
                                ref={section => scrollReferences['pre-teen-athlete-stretch'] = section}
                            >
                                Pre-Teen Athlete Stretch and Strengthen Class (Boys)
                            </div>
                        </div>
                        <div className="col-4_xs-11_md-4 no-padding--bot">
                            <div className="img-container minor-margin--bottom">
                                <img
                                    width="100%"
                                    src="/img/promos/preteen-stretch-strengthen.webp"
                                />
                            </div>
                        </div>
                        <div className="col-7_xs-11_md-7 no-padding--bot">
                            <p className="text-large">This is a 5 week pre-registered class for male athletes ages 10-13. Please call for any clarification on age restrictions.</p>

                            <ul className="styled minor-margin--bottom">
                                <li>
                                    <span className="bold">When:</span> Tuesday October 16th, 23rd, 30th, November 6th, 13th, 4:00pm - 5:00pm
                                </li>
                                <li>
                                    <span className="bold">Cost:</span> $100 +HST for 5 classes
                                </li>
                            </ul>

                            <p>Led by <Link to={getRoute('ourTeamMember', {member: 'adrienne-mcconnell'})} className="link">Dr. Adrienne McConnell</Link>, Chiropractor and owner of Pursuit. She has a special interest in youth athletes, and injuries specific to this age group. Her goal with young athletes is teaching them the strengthening and mobility techniques to try and prevent injury and time away from sport.</p>

                            <p className="text-large highlight">The class will focus on:</p>
                            <ul className="styled minor-margin--bottom">
                                <li>Proper stretching and warm-up/cool down techniques specific to various sports and muscle groups</li>
                                <li>Mobility education and how mobility can help prevent injury</li>
                                <li>Safe and effective form for basic strength moves (push-ups, squats, lunges, planks)</li>
                            </ul>

                            <p className="no-margin--bot">The main goal of this series is to teach body awareness and the value of preventative exercises / "pre-hab" to keep their body well maintained to continue throughout the season, in a fun and relaxed environment!</p>
                        </div>
                    </div>

                    <div
                        className="grid-center major-margin--bottom"
                    >
                        <div className="col-11">
                            <div
                                className="section-title text-large highlight"
                                ref={section => scrollReferences['post-natal-pilates'] = section}
                            >
                                Post-Natal Pilates for Mamma and Baby
                            </div>
                        </div>
                        <div className="col-11">
                            <p className="text-large">This is a 4 week pre-registered class.</p>

                            <ul className="styled minor-margin--bottom">
                                <li>
                                    <span className="bold">When:</span> Wednesday November 7th, 14th, 21st, 28th 11:00am - 12:15pm
                                </li>
                                <li>
                                    <span className="bold">Cost:</span> $85 +HST for 4 classes
                                </li>
                            </ul>

                            <p className="text-large">This class is for Mamma's (and their babes are welcome too!).</p>

                            <p>The class will be focused on safe and restorative movement for Mamma and followed by education on topics for Mamma and Baby.</p>

                            <p><Link to={getRoute('ourTeamMember', {member: 'adrienne-mcconnell'})} className="link">Dr. Adrienne McConnell</Link> is a Chiropractor, owner of Pursuit, and a Mammam:). She will teach the movement portion of the class, she is experienced in post-natal health as well as core restoration post baby and is passionate about supporting Mammas and helping them feels healthy and strong post baby.</p>

                            <p>The education portion following will be led by <Link to={getRoute('ourTeamMember', {member: 'naomi-ha'})} className="link">Dr. Naomi Ha</Link>, our Naturopathic Doctor. She will cover a brief informational session on various topics helpful for new mothers.</p>

                            <p>Each session will START with a 40 minute movement portion, and END with a 20 minute informative and educational session.</p>

                            <p>Invest in your own self-care as a new Mamma! Learn how to restore your body after pregnancy with safe and effective movement, nutrition, and education.</p>
                        </div>
                    </div>

                    <div className="grid-center">
                        <div className="col-11">
                            <div
                                className="section-title text-large highlight"
                                ref={section => scrollReferences['rest-and-digest'] = section}
                            >
                                Rest & Digest: 101
                            </div>
                        </div>
                        <div className="col-4_xs-11_md-4">
                            <div className="img-container">
                                <img
                                    width="100%"
                                    src="/img/promos/rest-and-digest/rest-and-digest-101.webp"
                                />
                            </div>
                        </div>
                        <div className="col-7_xs-11_md-7">
                            <p>Our naturopath, <Link to={getRoute('ourTeamMember', {member: 'naomi-ha'})} className="link">Dr. Naomi Ha</Link> took you through an informative seminar addressing the fundamentals of digestive health, strategies to manage at home, and how we could help!</p>

                            <ul className="styled decent-margin--bottom">
                                <li>
                                    <span className="bold">When:</span> Wednesday, August 15th, 7:30pm
                                </li>
                                <li>
                                    <span className="bold">Where:</span> Pursuit Integrative Health, 1039 Gerrard Street East, Toronto
                                </li>
                            </ul>

                            <p>This was a free seminar!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
